// src/layout/partials/menu.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Can from '../../../components/can';
import { useLayout } from '../LayoutContext';

const Menu = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { sidebarOpen, isXLUp, closeSidebar, isCollapsed, toggleCollapsed } = useLayout();

  const [openMenu, setOpenMenu] = useState(null);
  const toggleMenu = (menu) => setOpenMenu(openMenu === menu ? null : menu);
  const handleNav = () => { if (!isXLUp) closeSidebar(); };

  return (
    <aside
      id="layout-menu"
      className={`layout-menu menu-vertical menu bg-menu-theme ${sidebarOpen ? 'is-open' : ''} ${isXLUp && isCollapsed ? 'is-collapsed' : ''}`}
      aria-hidden={!sidebarOpen && !isXLUp}
      aria-label="Navigation principale"
    >
      <div className="app-brand demo">
        <Link to="/" className="app-brand-link" onClick={handleNav}>
          <span className="app-brand-logo demo" />
          <span className="app-brand-text demo menu-text fw-bolder ms-2"
            style={{ textTransform: 'uppercase', fontSize: '1.2rem' }}>
            TIGOON Connect
          </span>
        </Link>

        {/* Bouton collapse (desktop) */}
        {isXLUp && (
          <button
            className="btn btn-link p-0 ms-auto d-none d-xl-inline-flex"
            type="button"
            aria-label={isCollapsed ? 'Agrandir le menu' : 'Réduire le menu'}
            onClick={toggleCollapsed}
            title={isCollapsed ? 'Agrandir' : 'Réduire'}
          >
            <i className={`bx ${isCollapsed ? 'bx-chevron-right' : 'bx-chevron-left'} bx-sm`} />
          </button>
        )}

        {/* Bouton fermer (mobile) */}
        <button
          className="layout-menu-toggle menu-link text-large d-xl-none btn btn-link ms-2"
          onClick={closeSidebar}
          aria-label="Fermer le menu"
          type="button"
        >
          <i className="bx bx-x bx-sm align-middle" />
        </button>
      </div>

      <div className="menu-inner-shadow" />

      <ul className="menu-inner py-1">
        {/* ===================== DASHBOARD ===================== */}
        <Can perm="dashboard:view">
          <li className={`menu-item ${currentPath === '/dashboard' ? 'active' : ''}`}>
            <Link to="/dashboard" className="menu-link" onClick={handleNav}>
              <i className="menu-icon tf-icons bx bx-home-circle" />
              <span className="menu-title">TABLEAU DE BORD</span>
            </Link>
          </li>
        </Can>

        {/* ===================== GESTION SERVICES ===================== */}
        <Can perm="categories:read">
          <li className={`menu-item ${openMenu === 'categories' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('categories')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'categories'}
              aria-controls="submenu-categories"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-category" />
              <span className="menu-title">GESTION SERVICES</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-categories" className={`menu-sub ${openMenu === 'categories' ? 'show' : ''}`}>
              <li className={`menu-item ${currentPath === '/dashboard/categories' ? 'active' : ''}`}>
                <Link to="/dashboard/categories" className="menu-link" onClick={handleNav}>
                  <span className="menu-title">LISTE</span>
                </Link>
              </li>
              <Can perm="categories:create">
                <li className={`menu-item ${currentPath === '/dashboard/ajouter-categorie' ? 'active' : ''}`}>
                  <Link to="/dashboard/ajouter-categorie" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">AJOUT</span>
                  </Link>
                </li>
              </Can>
            </ul>
          </li>
        </Can>

        {/* ===================== INSCRIPTION ===================== */}
        <Can anyOf={['partners:read', 'vehicles:read', 'drivers:read']}>
          <li className={`menu-item ${openMenu === 'inscription' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('inscription')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'inscription'}
              aria-controls="submenu-inscription"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-user-circle" />
              <span className="menu-title">INSCRIPTION</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-inscription" className={`menu-sub ${openMenu === 'inscription' ? 'show' : ''}`}>
              <Can perm="partners:read">
                <li className={`menu-item ${currentPath === '/dashboard/partenaires' ? 'active' : ''}`}>
                  <Link to="/dashboard/partenaires" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">TIGOON</span>
                  </Link>
                </li>
              </Can>
              <Can perm="vehicles:read">
                <li className={`menu-item ${currentPath === '/dashboard/vehicules' ? 'active' : ''}`}>
                  <Link to="/dashboard/vehicules" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">VEHICULES</span>
                  </Link>
                </li>
              </Can>
              <Can perm="drivers:read">
                <li className={`menu-item ${currentPath === '/dashboard/chauffeurs' ? 'active' : ''}`}>
                  <Link to="/dashboard/chauffeurs" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">YANDEX</span>
                  </Link>
                </li>
              </Can>
            </ul>
          </li>
        </Can>

        {/* ===================== HISTORIQUE MODIFICATION ===================== */}
        <Can anyOf={['userPhone.history:read', 'vehicleChanges.history:read']}>
          <li className={`menu-item ${openMenu === 'histomodif' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('histomodif')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'histomodif'}
              aria-controls="submenu-histomodif"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-history" />
              <span className="menu-title">HISTORIQUE MODIFICATION</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-histomodif" className={`menu-sub ${openMenu === 'histomodif' ? 'show' : ''}`}>
              <Can perm="userPhone.history:read">
                <li className={`menu-item ${currentPath === '/dashboard/historique-numeros' ? 'active' : ''}`}>
                  <Link to="/dashboard/historique-numeros" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">NUMEROS</span>
                  </Link>
                </li>
              </Can>
              <Can perm="vehicleChanges.history:read">
                <li className={`menu-item ${currentPath === '/dashboard/historique-vehicules-modifies' ? 'active' : ''}`}>
                  <Link to="/dashboard/historique-vehicules-modifies" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">VEHICULES</span>
                  </Link>
                </li>
              </Can>
            </ul>
          </li>
        </Can>

        {/* ===================== TRANSACTIONS ===================== */}
        <Can anyOf={['transfers.history:read', 'soscredit.history:read']}>
          <li className={`menu-item ${openMenu === 'transactions' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('transactions')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'transactions'}
              aria-controls="submenu-transactions"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-transfer-alt" />
              <span className="menu-title">TRANSACTIONS</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-transactions" className={`menu-sub ${openMenu === 'transactions' ? 'show' : ''}`}>
              <Can perm="transfers.history:read">
                <li className={`menu-item ${currentPath === '/dashboard/historique-transferts' ? 'active' : ''}`}>
                  <Link to="/dashboard/historique-transferts" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">TRANSFERTS UV</span>
                  </Link>
                </li>
              </Can>
              <Can perm="soscredit.history:read">
                <li className={`menu-item ${currentPath === '/dashboard/historique-sos-credit' ? 'active' : ''}`}>
                  <Link to="/dashboard/historique-sos-credit" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">SOS CREDITS</span>
                  </Link>
                </li>
              </Can>
            </ul>
          </li>
        </Can>

        {/* ===================== ASSISTANCE ===================== */}
        <Can anyOf={['assistance:read', 'assistance:update']}>
          <li className={`menu-item ${openMenu === 'assistance' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('assistance')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'assistance'}
              aria-controls="submenu-assistance"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-support" />
              <span className="menu-title">ASSISTANCE</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-assistance" className={`menu-sub ${openMenu === 'assistance' ? 'show' : ''}`}>
              <li className={`menu-item ${currentPath === '/dashboard/demandes-assistances' ? 'active' : ''}`}>
                <Link to="/dashboard/demandes-assistances" className="menu-link" onClick={handleNav}>
                  <span className="menu-title">MES DEMANDES</span>
                </Link>
              </li>
            </ul>
          </li>
        </Can>

        {/* ===================== PARAMETRE ===================== */}
        <Can anyOf={['users:read', 'users:create', 'users:update', 'users:delete']}>
          <li className={`menu-item ${openMenu === 'parametre' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('parametre')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'parametre'}
              aria-controls="submenu-parametre"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-cog" />
              <span className="menu-title">PARAMETRE</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-parametre" className={`menu-sub ${openMenu === 'parametre' ? 'show' : ''}`}>
              <li className={`menu-item ${currentPath === '/dashboard/gestion-admins' ? 'active' : ''}`}>
                <Link to="/dashboard/gestion-admins" className="menu-link" onClick={handleNav}>
                  <span className="menu-title">LISTE</span>
                </Link>
              </li>
              <Can perm="users:create">
                <li className={`menu-item ${currentPath === '/dashboard/ajouter-admin' ? 'active' : ''}`}>
                  <Link to="/dashboard/ajouter-admin" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">AJOUT</span>
                  </Link>
                </li>
              </Can>
            </ul>
          </li>
        </Can>

        {/* ===================== WALLET ===================== */}
        <Can anyOf={['finance:read', 'finance:update']}>
          <li className={`menu-item ${openMenu === 'wallet' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('wallet')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'wallet'}
              aria-controls="submenu-wallet"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-wallet" />
              <span className="menu-title">WALLET</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-wallet" className={`menu-sub ${openMenu === 'wallet' ? 'show' : ''}`}>
              <li className={`menu-item ${currentPath === '/dashboard/wallet' ? 'active' : ''}`}>
                <Link to="/dashboard/wallet" className="menu-link" onClick={handleNav}>
                  <span className="menu-title">WALLET</span>
                </Link>
              </li>
              <li className={`menu-item ${currentPath === '/dashboard/historique-points' ? 'active' : ''}`}>
                <Link to="/dashboard/historique-points" className="menu-link" onClick={handleNav}>
                  <span className="menu-title">POINT</span>
                </Link>
              </li>
            </ul>
          </li>
        </Can>

        {/* ===================== PROMOTION ===================== */}
        <Can anyOf={['promotions:read', 'promotions:update', 'operations:read']}>
          <li className={`menu-item ${openMenu === 'promotion' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('promotion')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'promotion'}
              aria-controls="submenu-promotion"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-trophy" />
              <span className="menu-title">PROMOTION</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-promotion" className={`menu-sub ${openMenu === 'promotion' ? 'show' : ''}`}>
              <Can perm="promotions:read">
                <li className={`menu-item ${currentPath === '/dashboard/historique-promotions' ? 'active' : ''}`}>
                  <Link to="/dashboard/historique-promotions" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">PROMOTION DIMANCHE</span>
                  </Link>
                </li>
              </Can>
              <Can perm="operations:read">
                <li className={`menu-item ${currentPath === '/dashboard/toutes-operations' ? 'active' : ''}`}>
                  <Link to="/dashboard/toutes-operations" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">OPERATIONS</span>
                  </Link>
                </li>
              </Can>
            </ul>
          </li>
        </Can>

        {/* ===================== ACHETE TERRAIN ===================== */}
        {/* <Can anyOf={['promotions:read', 'promotions:update', 'operations:read']}> */}
          <li className={`menu-item ${openMenu === 'achete-terrain' ? 'open' : ''}`}>
            <button
              onClick={() => toggleMenu('achete-terrain')}
              className="menu-link menu-toggle"
              aria-expanded={openMenu === 'achete-terrain'}
              aria-controls="submenu-achete-terrain"
              type="button"
            >
              <i className="menu-icon tf-icons bx bx-home" />
              <span className="menu-title">ACHETE TON TERRAIN</span>
              {/* <i className="menu-arrow bx bx-chevron-right" aria-hidden="true" /> */}
            </button>

            <ul id="submenu-achete-terrain" className={`menu-sub ${openMenu === 'achete-terrain' ? 'show' : ''}`}>
              {/* <Can perm="promotions:read"> */}
                <li className={`menu-item ${currentPath === '/dashboard/historique-promotions' ? 'active' : ''}`}>
                  <Link to="/dashboard/sites" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">SITE</span>
                  </Link>
                </li>
              {/* </Can> */}
              {/* <Can perm="operations:read"> */}
                <li className={`menu-item ${currentPath === '/dashboard/ajout-site' ? 'active' : ''}`}>
                  <Link to="/dashboard/ajout-site" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">AJOUT SITE</span>
                  </Link>
                </li>

                <li className={`menu-item ${currentPath === '/dashboard/souscripteurs' ? 'active' : ''}`}>
                  <Link to="/dashboard/souscripteurs" className="menu-link" onClick={handleNav}>
                    <span className="menu-title">SOUSCRIPTEURS</span>
                  </Link>
                </li>
              {/* </Can> */}
            </ul>
          </li>
        {/* </Can> */}

      </ul>
    </aside>
  );
};

export default Menu;
